<template>
  <div id="app" class="vh-100">
    <div class="h-100">
      <TopBar />
      <router-view/>
    </div>
  </div>
</template>

<style>

</style>
<script>
import TopBar from "@/components/TopBar.vue";

export default {
  name: 'app',
  components: {
    TopBar,
  }
};
</script>
<style lang="scss">
  #app {
    background: url( https://media.thewave.com/images/homepage-birds-eye-view-deep-blue-ocean-the-w.width-1000.jpg ) no-repeat center center;
    background-size: cover;
  }
  h1,h2,h3,h4,h5 {
    color: #003d4c;
  }
  .wrapper {
    height: calc(100% - 103px);
  }
</style>
